<template>
  <b-row no-gutters>
    <b-col cols="12" md="6" offset-md="3" xl="4" offset-xl="4">
      <b-card class="border-0 mb-lg-4">
        <template #header class="bg-white">
          <h1 class="text-center font-weight-bold pt-lg-3 pt-sm-0">{{ $t('licensingCommunity.title') }}</h1>
          <h4 class="text-center font-weight-bold pt-lg-3 pt-sm-0">{{ $t('licensingCommunity.leading', { provinceCount: licensingProvinces.length }) }}</h4>
        </template>

        <div class="p-2">
          <h2 class="text-center mb-4">{{ $t('licensingCommunity.subtitle') }}</h2>
          <div v-if="loading">
            <dp-loading />
          </div>
          <div v-else>
            <b-form-group
              id="state-input-group"
              :label="$t('licensingCommunity.selectLocation')"
              label-for="state-input"
              :label-sr-only="true"
              class="mb-0"
            >
              <b-form-select
                id="state-input"
                v-model="selected"
                :options="options"
                @change="findCommunitiesByProvince"
                aria-describedby="error-feedback"
              >
                <template #first>
                  <b-form-select-option value="null" disabled>{{ $t('licensingCommunity.selectLocation') }}</b-form-select-option>
                </template>
              </b-form-select>
              <p v-show="error" class="text-danger" id="error-feedback">{{ $t('licensingCommunity.errorOccurred') }}</p>
            </b-form-group>

            <div class="mt-4" v-if="licensingCommunities && licensingCommunities.length > 0">
              <b-row>
                <b-col>
                  <p class="text-center mb-4 h4">
                    {{ $tc('licensingCommunity.communityCount', licensingCommunities.length, { count: licensingCommunities.length }) }}
                  </p>
                </b-col>
              </b-row>
              <b-row role="list">
                <b-col
                  cols="12"
                  lg="6"
                  v-for="(jurisdiction, index) in licensingCommunities"
                  :key="index"
                  class="mb-2 text-center text-lg-left"
                  role="listitem"
                >
                  <b-link :href="jurisdiction.organizationUrl">{{ jurisdiction.name }}</b-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <b-card-body class="pt-0">
          <b-row>
            <b-col>
              <hr class="my-5" />
              <h2 class="text-center">{{ $t('licensingCommunity.notSeeing') }}</h2>
              <p class="text-center mb-4 h4" v-html="$t('licensingCommunity.shop', { url: `${baseUrl}/signup/register` })" />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import { DpLoading } from '@docupet/component-library';

export default {
  name: 'FindLicensingCommunity',
  components: {
    DpLoading,
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    this.$store.dispatch('city/clearLicensingCommunities');
    this.$store.dispatch('city/findLicensingProvinces');
  },
  computed: {
    ...mapState({
      licensingCommunities: (state) => state.city.licensingCommunities,
      loading: (state) => state.city.loading,
      licensingProvinces: (state) => state.city.licensingProvinces,
      error: (state) => state.city.loadingCommunitiesError,
    }),
    options() {
      return this.licensingProvinces?.map(({ province }) => ({
        text: this.$t(`provincesAbbr.${province}`),
        value: province,
      }));
    },
    baseUrl() {
      return this.$store.getters['getBaseUrl'];
    },
  },
  methods: {
    findCommunitiesByProvince(input) {
      this.$store.dispatch('city/findLicensingCommunities', { province: input });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.card-header {
  background-color: $dp-white;
}
@media screen and (min-width: 768px) {
  .card {
    border-radius: 8px;
    -webkit-box-shadow: 1px 2px 3px $dp-shadow-1;
    box-shadow: 1px 2px 3px $dp-shadow-1;
  }
  .card-header {
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
}
</style>
